import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as actions from '../../../actions/SocietyPortal/AccountLedgerReportAction/AccountLedgerReportAction';
import { getAccountLedgerReport } from '../../../../axios/request/SocietyPortal/AccountLedgerReportReqs/AccountLedgerReportReqs';

function* getAccountLedgerReportSaga(action) {
    try {
        const response = yield call(getAccountLedgerReport, action.payload);
        const resData = response.data;
        yield put({ type: types.GET_ACCOUNT_LEDGER_REPORT_SUCCESS, payload: resData });
        if (action.payload.onSuccess) {
            action.payload.onSuccess(resData);
        }
    } catch (error) {
        yield put({ type: types.GET_ACCOUNT_LEDGER_REPORT_FAILURE, payload: error.response?.data?.message || 'Something went wrong' });
        if (action.payload.onError) {
            action.payload.onError(error.response?.data?.message || 'Something went wrong');
        }
    }
}

export function* accountLedgerReportWatcher() {
    yield takeEvery(types.GET_ACCOUNT_LEDGER_REPORT, getAccountLedgerReportSaga);
}
